export const defaultStyle = {
    footer: "relative w-full bg-mdlzPurple z-[90] pt-[80px] md:pt-[40px] lg:pt-0",
    borderTop: "custom-border-top bg-mdlzPurple",
    wrapper: "section-wrapper relative flex flex-col pt-[34px] pb-[50px] md:py-[50px] lg:py-[75px]",
    decoration:
        "absolute pointer-events-none top-[-160px] left-[60px] md:top-[-110px] md:left-[240px] lg:top-[-70px] lg:left-[280px] z-[90]",
    topContent: "w-full flex flex-col justify-between md:flex-row md:justify-[unset]",
    logoWrapper: "max-w-[171px] mx-auto mb-[35px] lg:mb-[60px] xl:mb-[35px] md:mx-[unset]",
    description: "my-[35px] flex flex-col gap-[15px]",
    descriptionCopy: {
        richTextWrapper:
            "w-full text-white md:max-w-[304px] lg:max-w-[342px] xl:max-w-[563px] flex flex-col gap-[15px]",
        heading1: "hidden",
        heading2: "subheading-text uppercase",
        heading3: "hidden",
        heading4: "hidden",
        heading5: "hidden",
        heading6: "hidden",
        paragraph: "body-text [&_a]:underline",
        ulList: "list-disc ml-[12px] body-text [&_a]:underline",
        list: "list-disc ml-[12px] body-text [&_a]:underline",
    },
    descriptionCta: "text-white btn-link font-bold",
    navigations: "flex flex-row justify-between my-[35px] md:pt-[62px] md:gap-[119px] lg:mt-[60px] xl:pt-0 xl:mt-0",
    navigationCol: "text-white flex flex-col gap-[15px] md:gap-[30px]",
    navigationLabel: "font-bold text-white body-text",
    navigationList: "flex flex-col gap-[10px] font-normal text-white",
    navigationLink: "body-link",
    bottomContent:
        "flex flex flex-col-reverse gap-[10px] md:flex-row md:w-full md:justify-between md:items-end mt-[14px]",
    copyright: "text-center text-white font-normal body-text md:text-left",
    socialLinksWrapper: "flex flex-wrap items-center justify-center gap-[10px]",
    socialLink: "block [&_img]:w-[36px] [&_img]:h-[36px] [&_img]:max-w-[36px] [&_img]:max-h-[36px]",
    hr: "w-full block h-[1px]",
    hrMob: "w-full block h-[1px] md:hidden",
}
